import { declareVueComponent } from '/vodalys/vvuejs'
import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'

import './vcreator18.vconsole.component.css'
import './vcreator18.vconsole.component.scss'
import './vcreator18.vconsole.component.source_list.scss'

import FCreatorTabs from './FCreatorTabs.vue'
import FCreatorComponent from './FCreatorComponent.vue'
import FCreatorTemplate from './FCreatorTemplate.vue'
import FCreatorCollection from './FCreatorCollection.vue'
import FCreatorSourceList from './FCreatorSourceList.vue'

declareVueComponent('FCreatorTabs', FCreatorTabs)
declareVueComponent('FCreatorSourceList', FCreatorSourceList)

declareVconsoleComponent('vcreator18Component', FCreatorComponent, 'vcreator18:component')
declareVconsoleComponent('vcreator18Template', FCreatorTemplate, 'vcreator18:template')
declareVconsoleComponent('vcreator18Collection', FCreatorCollection, 'vcreator18:collection')


